<template>
  <div>
    <div
      type="button"
      class="b-ticket-summary__expand mt-3"
      :class="collapseOpened">
      <button
        type="button"
        class="b-ticket-summary__expand__header"
        :class="iconCollapseOpened"
        @click="openCloseExpand">
        <div class="b-ticket-summary__expand__title">
          {{ dictionary.creditVoucherTitle }}
        </div>
      </button>
      <Loader v-if="isLoading"></Loader>
      <div class="b-ticket-summary__expand__content">
        <div class="b-ticket-summary__expand__text">
          {{ dictionary.creditVoucherAccordionSummary }}
        </div>
        <form
          v-if="!voucherAccepted"
          autocomplete="off"
          @submit.prevent="onSubmitCode">
          <div class="b-add-credit-voucher__wrapper">
            <div class="form-floating">
              <input
                id="voucherCode"
                v-model="voucherCode"
                type="text"
                class="form-control"
                :placeholder="dictionary.creditVoucherLabel" />
              <label for="firstname">{{ dictionary.creditVoucherLabel }}</label>
            </div>
            <button
              class="btn-icon btn-plus-icon btn-plus-icon--large"
              type="submit"
              aria-label="submit voucher code"
              :title="dictionary.creditVoucherButtonText"
              :disabled="disableAddButton"></button>
          </div>
        </form>
        <div v-else class="b-add-credit-voucher__voucher-holder">
          <div>
            <div class="b-add-credit-voucher__details__title">
              {{ dictionary.creditVoucherReviewCode }}
            </div>
            <div class="b-add-credit-voucher__details__value">
              {{ store.creditVoucher ? store.creditVoucher.voucherCode : null }}
            </div>
          </div>

          <div>
            <div class="b-add-credit-voucher__details__title">
              {{ dictionary.creditVoucherReviewValue }}
            </div>
            <div class="b-add-credit-voucher__details__value">
              {{
                roundToDigits(
                  store.creditVoucher
                    ? store.creditVoucher.discountAmount
                    : null
                )
              }}
              €
            </div>
          </div>

          <button
            class="btn-icon--remove"
            type="submit"
            aria-label="remove voucher code"
            @click="removeVoucher"></button>
        </div>
      </div>
    </div>
  </div>
  <ModalOverlay
    v-model="showActionModal"
    background-class="b-pop-up--alert-success b-pop-up__holder"
    header-background-class="b-pop-up__header">
    <template #header>
      <div class="b-pop-up__header__title">
        {{ dictionary.creditVoucherTitle }}
      </div>
    </template>
    <template #body>
      <div class="b-pop-up__content">
        <div
          class="b-pop-up__alert-success__icon"
          :class="modalSubmitStatus"></div>
        <div class="b-pop-up__alert-success__content__container">
          <div class="b-pop-up__alert-success__title">
            {{ modalSubmitStatusMessage }}
          </div>
          <div
            class="b-pop-up__alert-success__text"
            v-html="modalSubmitStatusMessageDesc"></div>
          <button
            type="button"
            class="b-pop-up__alert-success__cta"
            @click="() => (showActionModal = false)">
            {{ dictionary.creditVoucherModalButtonCloseText }}
          </button>
        </div>
      </div>
    </template>
  </ModalOverlay>
</template>

<script>
import useVuelidate from '@vuelidate/core'
import Loader from '../components/Shared/Loader.vue'
import ModalOverlay from '../components/ModalOverlay.vue'
import { useBookingStore } from '../store/BookingStore'
import postRequestHandler from '../../lib/postRequestHandler'

export default {
  components: { Loader, ModalOverlay },
  emits: ['get-voucher-data', 'remove-voucher-data'],
  setup() {
    return { v$: useVuelidate(), store: useBookingStore() }
  },
  data() {
    return {
      voucherCode: null,
      openCollapse: false,
      isLoading: false,
      errorMsgs: [],
      showActionModal: false,
      submitFail: false,
    }
  },
  computed: {
    iconCollapseOpened() {
      return this.openCollapse
        ? 'b-ticket-summary__expand__header__icon--open'
        : ''
    },
    collapseOpened() {
      return this.openCollapse ? 'b-ticket-summary__expand__open' : ''
    },
    modalSubmitStatus() {
      return this.submitFail
        ? 'b-pop-up__alert-success__icon--warning'
        : 'b-pop-up__alert-success__icon--success'
    },
    modalSubmitStatusMessage() {
      return this.submitFail
        ? this.errorMsgs[0]
        : this.dictionary.creditVoucherModalSuccessTitle
    },
    modalSubmitStatusMessageDesc() {
      // FIXME
      return this.submitFail
        ? this.errorMsgs[1]
        : this.dictionary.creditVoucherModalSuccessDesc
    },
    disableAddButton() {
      return !this.voucherCode
    },

    voucherAccepted() {
      return this.store.creditVoucher
    },
  },
  methods: {
    openCloseExpand() {
      this.openCollapse = !this.openCollapse
    },

    async onSubmitCode() {
      this.v$.$validate()

      if (this.v$.$invalid) {
        this.$nextTick(() => {
          this.showActionModal = true
        })
        return false
      }

      this.isLoading = true
      this.errorMsgs = []

      const postData = {
        voucherCode: this.voucherCode,
        amount: this.store.getTotalCart,
        culture: document.documentElement.lang,
        userSessionId: this.store.bookingProgress.usersessionId,
      }
      await postRequestHandler({
        postData,
        endpoint: this.configuration.creditVoucherSubmit,
        successCallback: this.handleSuccess,
        errorCallback: this.handleError,
        refreshTokenHandler: this.configuration.refresh,
        captchaAction: this.configuration.creditVoucherCaptchaAction,
      })
    },

    handleSuccess(response) {
      this.isLoading = false
      this.errorMsgs = []
      this.voucherCode = ''
      this.openCloseExpand()
      this.submitFail = false
      this.showActionModal = true
      this.store.assignCreditVoucher(response.data)
    },

    handleError(messages) {
      this.errorMsgs = messages
      this.isLoading = false
      this.submitFail = true
      this.$nextTick(() => {
        this.showActionModal = true
      })
    },

    async removeVoucher() {
      if (!this.store.creditVoucher.voucherCode) {
        return false
      }
      this.isLoading = true
      this.errorMsgs = []

      const postData = {
        voucherCode: this.store.creditVoucher.voucherCode,
        userSessionId: this.store.bookingProgress.usersessionId,
      }

      await postRequestHandler({
        postData,
        endpoint: this.configuration.creditVoucherRemove,
        successCallback: this.handleSuccessRemove,
        errorCallback: this.handleErrorRemove,
        refreshTokenHandler: this.configuration.refresh,
        captchaAction: this.configuration.creditVoucherCaptchaAction,
      })
    },

    handleSuccessRemove() {
      this.isLoading = false
      this.errorMsgs = []
      this.v$.$reset()
      this.store.removeCreditVoucher()
    },

    handleErrorRemove(messages) {
      this.errorMsgs = messages
      this.isLoading = false
      this.submitFail = true
      this.$nextTick(() => {
        this.showActionModal = true
      })
    },

    roundToDigits(price) {
      return (
        price &&
        parseFloat(price).toLocaleString(document.documentElement.lang, {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })
      )
    },
  },
}
</script>
